export const LOAD_APPEAL = 'LOAD_APPEAL';
export const APPEAL_LOADED = 'APPEAL_LOADED';
export const APPEAL_LOAD_FAILED = 'APPEAL_LOAD_FAILED';

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';

export const DOWNLOAD_ALL_FILES = 'DOWNLOAD_ALL_FILES';